import { $persons } from '~/src/game';

export const getSpawnGeneration = (parentIds: string[]) => {
  const parentGen1 = $persons[parentIds[0]]?.generation;
  const parentGen2 = $persons[parentIds[0]]?.generation;

  return (Math.max(parentGen1, parentGen2) || 0) + 1;
};
